module.exports = __webpack_public_path__ + "img/CardsStore01.2049f379.png";